import { render, staticRenderFns } from "./NbnTicketManagement.vue?vue&type=template&id=71662ace&scoped=true"
import script from "./NbnTicketManagement.vue?vue&type=script&lang=js"
export * from "./NbnTicketManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71662ace",
  null
  
)

export default component.exports